
<template>
  <div>
    <van-field v-model="selectedCargo" readonly clickable :label="labelTitle" :placeholder="'点击选择'+labelTitle" @click="showSearchPage" :required="isRequired"/>
    
    <!-- 搜索页面 -->
    <van-popup v-model="showSearch" position="right" style="width:100%;height:100%;">
        <div class="search-box " >

                    <div class="search-top">
                      <div class="search-input">
                        <van-icon name="search" size="24px"/>
                        <input placeholder="请输入品种名称" v-model="keyword" @input="pinzhongInput"/>
                      </div>
                      <van-button  block @click="onSearch" class="search-button">搜索</van-button>
                    </div>
                    
<!--            <van-search v-model="keyword" placeholder="请输入品种名称" show-action @search="onSearch" style="border-radius: 5px;">-->
<!--                <template #action>-->
<!--&lt;!&ndash;                <button @click="onSearch" class="search-button">搜索</button>&ndash;&gt;-->
<!--                  <van-button  block @click="onSearch"-->
<!--                               class="search-button"-->
<!--                  >搜索</van-button>-->
<!--                </template>-->
<!--            </van-search>-->


            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" >
                <van-cell
                v-for="item in filteredList"
                :key="item.id"
                :title="item.pinming"
                @click="selectItem(item)"
                style="font-size: 18px"
                />
            </van-list>
            <div class="back-btn-box "><van-button color="#316892" block @click="goBack"
            style="border-radius: 5px"
            >返回</van-button></div>
        </div>
      
      
      
    </van-popup>
    
  </div>
</template>

<script>
import {Toast} from "vant";
import steamApi from "@/fetch/steamApi.js";
export default {
    props:{
        labelTitle:{
            type:String,
            default:"",
        },
        selectType:{
            type:String,
            default:"",
        },
        isRequired:{
          type:Boolean,
          default:false
        }
    },
  data() {
    return {
      selectedCargo: '',
      showSearch: false,
      keyword: '',
      cargoList: [],
      filteredList: [],
      loading: false,
      finished: false,
      page: 1,
      pageSize: 10,
      timer: null,
    }
  },
  created() {
  },
  methods: {
    showSearchPage() {
      this.showSearch = true;
      document.title = "选择品种"
      this.fetchCargoList();
    },
    pinzhongInput(){
      if(this.timer){
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(()=>{
        this.onSearch()
      },300)
    },
    onSearch() {
      this.page = 1;
      this.filteredList = [];
      this.fetchCargoList();
    },
    onLoad() {
      this.page++;
      this.fetchCargoList();
    },
    selectItem(item) {
      this.selectedCargo = item.pinming;
      this.showSearch = false;
      var postData = {
        selectType:this.selectType,
        value:item
      };
      document.title = "槽车蒸洗预约"

      this.$emit("handleCargoSelect", postData);
      this.keyword = ''
    },
    goBack(){
      this.showSearch = false
      document.title = "槽车蒸洗预约"
      this.keyword = ""

    },
    async fetchCargoList() {
      this.loading = true;
      try {
        if(this.keyword){
            var that = this;
            steamApi.fetchCargoLists(that.keyword).then(function(res) {
                var resData = JSON.parse(res);
                if( resData.data && resData.data.length>0)
                {
                  if (that.page === 1) {
                    that.filteredList = resData.data;
                  } else {
                      that.filteredList = [...that.filteredList, ...resData.data];
                  }
                  
                }
                else{
                  if(resData.data && resData.data.length==0){
                    Toast.fail("未搜索到品种");
                  }else {
                    Toast.fail(resData.message);
                  }

                  return
                }

                that.finished = resData.data.length < that.pageSize;
                
            }).catch(function(err) {
                console.log(err)
                Toast.fail('连接失败，请刷新页面');
            });
        }
        else{
            this.filteredList = [];
        }
        
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>
<style lang="less" scoped>
.search-box{
    width:100%;
    position:relative;
  .search-top{
    margin-top: 15px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 4px;

    .search-input{
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 3px;
      padding: 0 15px;
      background: #F7F8FA;
      width: 85vw;
      height: 50px;
      border-radius: 30px;
      margin:0 10px;
      input{
        background: none;
        width: 60vw;
        font-size: 16px;
      }
    }
    .search-button{
      margin: 0;
      padding: 0 10px !important;
      border-radius: 30px;
      height: 50px !important;
      caret-color: transparent;
      border: none;
      font-size: 18px;
      white-space: nowrap; // 防止按钮文字换行
    }
  }

    .back-btn-box{
        position: fixed;
        bottom: 2rem;
        left: 1rem;
        right: 1rem;
        display: block;
    }
}


</style>
